<template>
  <div class="card">
    <div class="card-header"><h2 style="font-size: 20px;">Delivery Information</h2></div>
    <div class="card-body">

        <div row-justify="center">
          <b-row>
            <b-col>
              <b-alert variant="warning" dismissible :show=hasDataFile >
                Please Note: All Data Files will be delivered via email ONLY.  You will receive Data Files at the email address entered on the
                customer information page.
              </b-alert>
              <b-alert variant="warning" dismissible :show=hasReplacement >
                OVR will send you a receipt by mail.
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-row class="mt-2">
                <b-col class="font-weight-bold">Contact Address: </b-col>
              </b-row>
              <b-row>
                <b-col>{{profile?.address?.streetAddress}}</b-col>
              </b-row>
              <b-row>
                <b-col>{{profile?.address?.poBox}}</b-col>
              </b-row>
              <b-row>
                <b-col>
                  {{profile?.address?.mnCity ? profile?.address?.mnCity.label : profile?.address?.city}}, {{profile?.address?.state}} {{profile?.address?.zip}}
                </b-col>
              </b-row>
              <b-row v-if="profile?.address?.international">
                <b-col>{{profile?.address?.countryName}}</b-col>
              </b-row>
            </b-col>
            <b-col md="6" v-if="!isDataFileOnly">
              <BaseCheckboxInput label="Ship to Contact Address"
                                 v-model="shippingInfo.sameAddress"
                                 :v="$v.shippingInfo.sameAddress"
                                 slug="sameAddress"
                                 setId="sameAddress"
              />
            </b-col>
          </b-row>
          <div v-if="!shippingInfo.sameAddress" class="mt-2 pt-2 border-top">
            <h6 class="font-weight-bold">Shipping Address</h6>
            <b-row>
              <b-col cols="12" md="6" lg="4">
                <BaseTextInput v-model="shippingInfo.firstName"
                               :v="$v.shippingInfo.firstName"
                               slug="shippingFirstName"
                               setId="shippingFirstName"
                               label="First Name"
                               maxlength="50"
                />
              </b-col>
              <b-col cols="12" md="6" lg="4">
                <BaseTextInput v-model="shippingInfo.lastName"
                               :v="$v.shippingInfo.lastName"
                               slug="shippingLastName"
                               setId="shippingLastName"
                               label="Last Name"
                               maxlength="50"
                />
              </b-col>
            </b-row>
<!--            <b-row>-->
<!--              <b-col cols="12" md="6" lg="4">-->
<!--                <BaseCheckboxInput label="International Shipping Address"-->
<!--                                   v-model="shippingInfo.international"-->
<!--                                   :v="$v.shippingInfo.international"-->
<!--                                   slug="internationalShipping"-->
<!--                                   setId="internationalShipping"-->
<!--                                   legend="Shipping Outside the US"-->
<!--                />-->
<!--              </b-col>-->
<!--            </b-row>-->
            <b-row>
              <b-col cols="12" md="6" lg="4">
                <BaseTextInput v-model="shippingInfo.streetAddress"
                               :v="$v.shippingInfo.streetAddress"
                               slug="streetAddress"
                               set-id="streetAddress"
                               label="Address Line 1"
                               maxlength="90"
                />
              </b-col>
              <b-col cols="12" md="6" lg="4">
                <BaseTextInput v-model="shippingInfo.poBox"
                               :v="$v.shippingInfo.poBox"
                               slug="poBox"
                               setId="poBox"
                               label="Address Line 2"
                               maxlength="90"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6" lg="3" v-if="!isMn">
                <BaseTextInput v-model="shippingInfo.city"
                               :v="$v.shippingInfo.city"
                               slug="addressCity"
                               label="City"
                               maxLength="100"
                />
              </b-col>
              <b-col cols="12" md="6" lg="3" v-if="isMn">
                <BaseSearchableSelector v-model="shippingInfo.mnCity"
                                        :v="$v.shippingInfo.mnCity"
                                        label="City"
                                        :options = cityOptions
                />
              </b-col>
              <b-col cols="12" md="6" lg="3" v-if="!shippingInfo.international">
                <BaseSelector v-model="shippingInfo.state"
                              :v="$v.shippingInfo.state"
                              label="State"
                              slug="addressState"
                              setId="addressState"
                              :options=opts.stateOptions
                />
              </b-col>
              <b-col cols="12" md="6" lg="3" v-if="!shippingInfo.international">
                <BaseMaskedTextInput v-model="shippingInfo.zip"
                                     :v="$v.shippingInfo.zip"
                                     slug="zip"
                                     setId="zip"
                                     label="Zip Code"
                                     mask="#####-####"
                />
              </b-col>
              <b-col cols="12" md="6" lg="3" v-if="shippingInfo.international">
                <BaseTextInput v-model="shippingInfo.state"
                               :v="$v.shippingInfo.state"
                               slug="addressState"
                               setId="addressState"
                               label="State/Province/District"
                               maxlength="28"
                />
              </b-col>
              <b-col cols="12" md="6" lg="3" v-if="shippingInfo.international">
                <BaseTextInput v-model="shippingInfo.zip"
                               :v="$v.shippingInfo.zip"
                               slug="zip"
                               setId="zip"
                               label="Postal Code/ZIP Code"
                               maxlength="9"
                />
              </b-col>
              <b-col cols="12" md="6" lg="3" v-if="shippingInfo.international">
                <BaseSelector v-model="shippingInfo.country"
                              :v="$v.shippingInfo.country"
                              label="Country"
                              slug="addressCountry"
                              setId="addressCountry"
                              textField="description"
                              valueField="code"
                              :options=countryOptions
                />
              </b-col>
            </b-row>
          </div>
          <b-table hover
                   :items="shippingOptions"
                   :fields="shippingFields"
                   selectable
                   select-mode='single'
                   @row-selected="handleShippingSelected"
                   caption-top
                   v-if="!isDataFileOnly"
                   responsive
          >
            <template #table-caption>Select one option below</template>
            <template #cell(select)="row">
              <b-form-radio v-model="shippingInfo.shippingType" :value="row.item.code" readonly="" :aria-label="row.item.method"></b-form-radio>
            </template>
            <template v-slot:cell(fee)="row">
              <span v-if="row.item.fee != null">
                ${{row.item.fee}}
              </span>
            </template>
          </b-table>
          <div v-if="isRush" class="pt-2 border-top">
            <b-row>
              <b-col>
                <p>
                  You must upload a pre-paid shipping label that includes the carrier pick-up from MDH to complete the order.
                  If you do not upload a pre-paid shipping label, MDH will mail your order through standard international mail to the address
                  you provided.
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4" lg="2">
                <FileAttachment
                        v-on:attachment-added="handleUploadSuccess"
                        v-on:attachment-failed="handleUploadFailure"
                        :attachmentTypeOptions="attachmentOptions"
                        :order="orderNumber"
                        describedBy="attachments"
                        textField="method"
                        valueField="code"
                />
              </b-col>
              <b-col cols="12" md="8" lg="10">
                <AttachmentList :value="attachments" modalId="shipping"/>
              </b-col>
            </b-row>
          </div>
        </div>

    </div>
  </div>

</template>
<script>


import axiosRetry from 'axios-retry'
import axios from "axios"
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import {toastService} from "@/mixins/toastService";
import LocalStorageService from "@/common/LocalStorageService";
import BaseSelector from "@/components/templates/input/BaseSelector.vue";
import {maxLength, requiredIf} from "vuelidate/lib/validators";
import {commonOptions} from "@/mixins/commonOptions";
import BaseSearchableSelector from "@/components/templates/input/BaseSearchableSelector.vue";
import BaseMaskedTextInput from "@/components/templates/input/BaseMaskedTextInput.vue";
import BaseCheckboxInput from "@/components/templates/input/BaseCheckboxInput.vue";
import FileAttachment from "@/components/templates/input/FileAttachment.vue";
import AttachmentList from '@/components/templates/display/AttachmentList.vue';

const localStorageService = LocalStorageService.getService();


axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  });


export default {
  components: {
    BaseCheckboxInput,
    BaseSearchableSelector,
    BaseSelector,
    BaseTextInput,
    BaseMaskedTextInput,
    FileAttachment,
    AttachmentList,
  },
  data: () => {
    return {
      shippingFields: [
        {key: "select", label: 'Select', sortable:false},
        {key: 'method', label:'Shipping Method', sortable:true},
        {key: 'fee', label:'Fee', sortable:true},
        {key: 'description', label:'Description', sortable:true},
      ],
      shippingInfo: {
        firstName: null,
        lastName: null,
        streetAddress: null,
        poBox: null,
        city: null,
        mnCity: null,
        state: null,
        zip: null,
        country: 'US',
        addressType: "SHIPPING",
        shippingType: null,
        international: false,
        sameAddress: true,
      },
      shippingOptions: [],
      orderNumber: null,
      attachmentOptions: [{code: 'SHIPPING', description: 'Rush Shipping Label'}],
      attachments: [],
    }
  },
  props: {
    order: [Object],
    cityOptions: [Array],
    products: [Array],
    profile: [Object],
    countryOptions: [Array],
    hasDataFile: [Boolean],
    isDataFileOnly: [Boolean],
    hasReplacement: [Boolean],
    flag: [Boolean],
  },
  mixins: [
    commonOptions
  ],
  validations() {
        return {
          shippingInfo: {
            firstName: { required: requiredIf(function(){ return !this.shippingInfo.sameAddress && !this.isDataFileOnly }) },
            lastName: { required: requiredIf(function(){ return !this.shippingInfo.sameAddress && !this.isDataFileOnly }) },
            international: { required: requiredIf(function(){ return !this.isDataFileOnly })  },
            mnCity: { required: requiredIf(function(){ return !this.shippingInfo.city && !this.shippingInfo.sameAddress && !this.isDataFileOnly }) },
            city: { required: requiredIf(function(){ return !this.shippingInfo.mnCity && !this.shippingInfo.sameAddress && !this.isDataFileOnly }) },
            country: { required: requiredIf(function(){ return !this.shippingInfo.sameAddress && !this.isDataFileOnly }) },
            state: { required: requiredIf(function(){ return !this.shippingInfo.sameAddress && !this.isDataFileOnly && !this.shippingInfo.international }) },
            zip: { required: requiredIf(function(){ return !this.shippingInfo.sameAddress && !this.isDataFileOnly }) },
            shippingType: { required: requiredIf(function(){ return !this.isDataFileOnly })  },
            streetAddress: {
              required: requiredIf(function(){ return !this.shippingInfo.sameAddress && !this.isDataFileOnly }),
              maxLength: maxLength(90),
            },
            poBox: {
              required: false,
              maxLength: maxLength(90),
            },
            sameAddress: { required: requiredIf(function(){ return !this.isDataFileOnly }) },
          },
          attachments: { required: requiredIf(function(){ return this.isRush })},
          form: [ 'shippingInfo', 'attachments' ]
        }
  },
  mounted() {
    this.orderNumber = localStorageService.getOrderNumber();
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/order/shippingAddress/`+ this.orderNumber, this.shippingInfo)
          .then(response=>{
            this.$emit('on-submit')
            toastService.showRootToast("Shipping Address Submitted", "Shipping address has been updated" , "success", this.$root)
          })
          .catch(err => {
            toastService.showRootToast("Error", "An error has occurred" , "danger", this.$root)
          })
    },
    loadShippingOptions() {
      let international = false
      if(this.shippingInfo.sameAddress) {
          international = this.profile.address.international
        } else {
          international = this.shippingInfo.international
        }
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/options/shipping/` + international)
              .then(response=>{
                this.shippingOptions = response.data
              })
    },
    handleUploadSuccess(value) {
      toastService.showRootToast('File Uploaded', 'The file has been successfully uploaded to this application', 'success', this.$root);
      this.attachments.push(value)
    },
    handleUploadFailure(){
      toastService.showRootToast('Upload Failed', 'File Upload Failed','danger', this.$root);
    },
    handleShippingSelected(item) {
      if (item.length === 1) {
        this.shippingInfo.shippingType = item[0].code
      } else {
        this.shippingInfo.shippingType = null
      }
    },
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid, 'shipping')
      return isValid
    },
  },
  computed: {
    isMn() {
      return this.shippingInfo.state === 'MN'
    },
    stateVal() {
      return this.shippingInfo.state
    },
    isRush() {
      return this.shippingInfo.shippingType === 'INTERNATIONAL_RUSH'
    },
  },
  watch: {
    flag(value) {
      if (value) {
        this.loadShippingOptions()
      }
    },
    stateVal() {
      if(this.isMn) {
        let exists = this.cityOptions.filter(c => c.label.toUpperCase() === this.shippingInfo.city?.toUpperCase())
        if (exists.length > 0) {
          this.shippingInfo.mnCity = exists[0]
        } else {
          this.shippingInfo.mnCity = null
        }
        this.shippingInfo.city = null
      } else if (!this.isMn && this.shippingInfo.mnCity && this.shippingInfo.mnCity.label) {
          this.shippingInfo.city = this.shippingInfo.mnCity.label
          this.shippingInfo.mnCity = null
      }
    },
    'shippingInfo.international'(value) {
      if(value){
        this.shippingInfo.country = null;
      } else {
        this.shippingInfo.country = 'US';
      }
      this.shippingInfo.state = null;
      this.shippingInfo.mnCity = null;
      this.shippingInfo.city = null;
      this.shippingInfo.zip = null;
      this.shippingInfo.streetAddress = null
      this.shippingInfo.poBox = null
      this.shippingInfo.shippingType = null

      this.loadShippingOptions();
    },
    'shippingInfo.sameAddress'(value) {
      this.loadShippingOptions()
    },
    order() {
      if (this.order?.shippingAddress) {
        let existing = this.order?.shippingAddress

        this.shippingInfo = {
              firstName: existing.firstName,
              lastName: existing.lastName,
              streetAddress: existing.streetAddress,
              poBox: existing.poBox,
              city: existing.city,
              mnCity: existing.mnCity,
              state: existing.state,
              zip: existing.zip,
              country: existing.country,
              addressType: "SHIPPING",
              shippingType: this.order?.shippingType?.code,
              international: existing.country !== 'US',
        }
      }
    },
  },
}
</script>

<style>
h5 {
  font-weight: bold;
  font-family: inherit;
}
</style>
